import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ParcelIconModule } from '../../Entity/Parcel/Icon/parcelIcon.module';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AceModule } from '../../UI-Lib/ACE/ace.module';
import { DirectivesModule } from '../../UI-Lib/Directives/directives.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import {
    QuickSearchCriteriaPanelComponent
} from './Criteria/Quick-Search-Criteria-Panel/quickSearchCriteriaPanel.component';
import { QuickSearchCriteriaComponent } from './Criteria/quickSearchCriteria.component';
import { QuickSearchCriteriaModule } from './Criteria/quickSearchCriteria.module';
import { QuickSearchComponent } from './quickSearch.component';
import { QuickSearchResultComponent } from './Results/quickSearchResult.component';
import { SearchResultCompanyComponent } from './Results/Result-Company/searchResultCompany.component';
import { SearchResultExtraComponent } from './Results/Result-Extra/searchResultExtra.component';
import { SearchResultParcelComponent } from './Results/Result-Parcel/searchResultParcel.component';
import { SearchResultSiteComponent } from './Results/Result-Site/searchResultSite.component';

const hybridAdapterUtility = new HybridAdapterUtility();

@NgModule({
    imports: [
        CommonModule,
        QuickSearchCriteriaModule,
        ParcelIconModule,
        SharedPipesModule,
        DirectivesModule,
        AceModule
    ],
    declarations: [
        QuickSearchComponent,
        QuickSearchCriteriaPanelComponent,
        QuickSearchResultComponent,
        SearchResultCompanyComponent,
        SearchResultExtraComponent,
        SearchResultParcelComponent,
        SearchResultSiteComponent
    ],
    exports: [
        QuickSearchComponent,
        SearchResultCompanyComponent,
        SearchResultExtraComponent,
        SearchResultParcelComponent,
        SearchResultSiteComponent
    ]
})
export class QuickSearchModule {
    static setupModule(): void {
        hybridAdapterUtility.downgradeNg2Component('quickSearchCriteria', QuickSearchCriteriaComponent);
        hybridAdapterUtility.downgradeNg2Component('quickSearch', QuickSearchComponent);
    }
}
